import {
  ASSETS_HEALTH_STATUS_ID,
  ASSETS_HEALTH_STATUS_LABEL,
  ASSET_ASSESSABILITY_ID,
  ASSET_ASSESSABILITY_LABEL,
  ASSETS_CONDITION_ID,
  ASSETS_CONDITION_LABEL,
  DATA_COVERAEGE_ID,
  DATA_COVERAEGE_LABEL,
  CAMERA_INSTALLED_ID,
  CAMERA_INSTALLED_LABEL,
} from './types/filter.enums';
import { FilterOption } from '@/components/uiKit/FiltersGroup/types';

export const ASSETS_HEALTH_STATUS_ITEMS: FilterOption[] = [
  {
    id: ASSETS_HEALTH_STATUS_ID.CRITICAL,
    label: ASSETS_HEALTH_STATUS_LABEL.CRITICAL,
  },
  {
    id: ASSETS_HEALTH_STATUS_ID.ALARM,
    label: ASSETS_HEALTH_STATUS_LABEL.ALARM,
  },
  {
    id: ASSETS_HEALTH_STATUS_ID.MONITOR,
    label: ASSETS_HEALTH_STATUS_LABEL.MONITOR,
  },
  {
    id: ASSETS_HEALTH_STATUS_ID.HEALTHY,
    label: ASSETS_HEALTH_STATUS_LABEL.HEALTHY,
  },
  {
    id: ASSETS_HEALTH_STATUS_ID.NA,
    label: ASSETS_HEALTH_STATUS_LABEL.NA,
  },
];

export const ASSET_ASSESSABILITY_ITEMS: FilterOption[] = [
  {
    id: ASSET_ASSESSABILITY_ID.ASSESSABLE,
    label: ASSET_ASSESSABILITY_LABEL.ASSESSABLE,
  },
  {
    id: ASSET_ASSESSABILITY_ID.NOT_ASSESSABLE,
    label: ASSET_ASSESSABILITY_LABEL.NOT_ASSESSABLE,
  },
];

export const ASSETS_CONDITION_ITEMS: FilterOption[] = [
  {
    id: ASSETS_CONDITION_ID.STATUS_CHANGED,
    label: ASSETS_CONDITION_LABEL.STATUS_CHANGED,
  },
  {
    id: ASSETS_CONDITION_ID.NO_STATUS_CHANGE,
    label: ASSETS_CONDITION_LABEL.NO_STATUS_CHANGE,
  },
];

export const DATA_COVERAGE_ITEMS: FilterOption[] = [
  {
    id: DATA_COVERAEGE_ID.OFFLINE,
    label: DATA_COVERAEGE_LABEL.OFFLINE,
  },
  {
    id: DATA_COVERAEGE_ID.SEMI,
    label: DATA_COVERAEGE_LABEL.SEMI,
  },
  {
    id: DATA_COVERAEGE_ID.ONLINE,
    label: DATA_COVERAEGE_LABEL.ONLINE,
  },
];

export const CAMERA_INSTALLED_ITEMS: FilterOption[] = [
  {
    id: CAMERA_INSTALLED_ID.CAMERA,
    label: CAMERA_INSTALLED_LABEL.CAMERA,
  },
  {
    id: CAMERA_INSTALLED_ID.NO_CAMERA,
    label: CAMERA_INSTALLED_LABEL.NO_CAMERA,
  },
];
